import { Component } from '@angular/core';
import { NavigationService } from '../../service/navigation.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent {
  version: string = 'v3.12.5';

  constructor(public navigationService: NavigationService) {}

  get isNavCollapsed(): boolean {
    return !this.navigationService.isExpanded;
  }

}
